export function featuredPropertiesSlider() {
    let slider = $(".featured-properties-slider .slider");
    let clone = slider.find(".item.large").clone();
    $(".featured-properties-slider").append(clone);
    slider.find(".item.large").removeClass("large").addClass("hide");

    slider.slick({
        infinite: false,
        cssEase: 'ease-in-out',
        dots: false,
        prevArrow: '.slider-prev',
        nextArrow: '.slider-next',
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 9999,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    variableWidth: true
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/featuredPropertiesSlider.js